import type { Client } from '../../../api/client.js';
import type { EntreeJournal } from '../types.js';

/** Journal horodaté du dossier (`dossiers.journal`), lu page après page par le curseur du serveur (PARITE-4, onglet « Journal »). */
export type { EntreeJournal };

export interface PageJournal {
  items: EntreeJournal[];
  nextCursor: string | null;
}

export interface SourceJournal {
  page(curseur?: string): Promise<PageJournal>;
}

export function creerSourceJournal(client: Client, dossierId: string): SourceJournal {
  return {
    async page(curseur) {
      const page = await client.appeler<PageJournal>('dossiers.journal', {
        parametres: { dossierId },
        ...(curseur ? { requete: { cursor: curseur } } : {}),
      });
      if (!page || !Array.isArray(page.items)) throw new Error('Le journal du dossier est indisponible. Réessayez.');
      return { items: page.items, nextCursor: page.nextCursor ?? null };
    },
  };
}
